import React, { useState, useEffect } from 'react';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button, Divider, Dialog, DialogContent, DialogActions } from '@material-ui/core';

// Services
import { addSessionOption } from 'services/requests';
import { amountToSend, isValidAmount } from 'services/helpers';

// Components
import Spinner from 'components/spinner';

// Views
import SessionOptionForm from './session-options-form';

// Messages
import messages from 'messages.json';

// ----------------------------------------------------------------------------------------------- \\
// --------------------------------------- ADD SESSION OPTION ------------------------------------ \\
// ----------------------------------------------------------------------------------------------- \\

const AddSessionOption = ({ onClose, refetch, session }) => {
    const { enqueueSnackbar } = useSnackbar();

    const [state, setState] = useState({
        loading: false,
        price: '',
        name: '',
        description: '',
    });

    function onAdd() {
        if (state.price === '' || state.name === '') {
            enqueueSnackbar(messages['fields.required'], { variant: 'warning' });
        }
        else if (!isValidAmount(state.price)) {
            enqueueSnackbar('Veuillez saisir un montant valide', { variant: 'warning' });
        }
        else {
            setState({ ...state, loading: true });
        }
    }

    useEffect(() => {
        if (state.loading) {
            addSessionOption(session.id, {
                price: amountToSend(state.price),
                name: state.name,
                description: state.description,
            }).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    refetch();
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setState({ ...state, loading: false });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loading]);

    if (state.loading) return <Spinner />;

    return (
        <Dialog open fullWidth>
            {state.loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            Ajouter une option à la session
                        </p>
                        {/* -------------------- FORM -------------------- */}
                        <SessionOptionForm
                            state={state}
                            setState={setState}
                        />
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button onClick={onClose} variant="contained">
                            Annuler
                        </Button>
                        <Button onClick={onAdd} variant="contained">
                            Ajouter
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};

export default AddSessionOption;
